import store from '@state/store'

export default [
  {
    path: '/',
    name: 'home',
    component: () => lazyLoadView(import('@views/dashboard')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn'] && !store.getters['auth/userProfile']) {
        // Redirect to the dashboard page instead
        next()
      } else if(store.getters['auth/loggedIn'] && store.getters['auth/userProfile']){
        next({ name: 'my-services' })
      }
      else {
        // Continue to the login page
        next({ name: 'clientLogin' })
      }
    },
  },
  {
    path: '/admin',
    name: 'dashboard',
    component: () => lazyLoadView(import('@views/dashboard')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn'] && !store.getters['auth/userProfile']) {
        // Redirect to the dashboard page instead
        next()
      } else if(store.getters['auth/loggedIn'] && store.getters['auth/userProfile']){
        next({ name: 'my-services' })
      }
      else {
        // Continue to the login page
        next({ name: 'login' })
      }
    },
  },
  {
    path: '/map',
    name: 'map',
    component: () => lazyLoadView(import('@views/map')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn'] && !store.getters['auth/userProfile']) {
        // Redirect to the dashboard page instead
        next()
      } else if(store.getters['auth/loggedIn'] && store.getters['auth/userProfile']){
        next({ name: 'my-services' })
      }
      else {
        // Continue to the login page
        next({ name: 'login' })
      }
    },
  },
  {
    path: '/admin/client-center',
    name: 'client-center',
    component: () => lazyLoadView(import('@views/client-center')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn'] && store.getters['auth/getUserRole'] != null) {
        // Redirect to the dashboard page instead
        next()
      } else {
        // Continue to the login page
        next({ name: 'login' })
      }
    },
  },
  {
    path: '/admin/invoices',
    name: 'admininvoices',
    component: () => lazyLoadView(import('@views/invoices')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn'] && store.getters['auth/getUserRole'] != null) {
        // Redirect to the dashboard page instead
        next()
      } else {
        // Continue to the login page
        next({ name: 'login' })
      }
    },
  },
  {
    path: '/admin/driver-center',
    name: 'driver-center',
    component: () => lazyLoadView(import('@views/driver-center')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn'] && store.getters['auth/getUserRole'] != null) {
        // Redirect to the dashboard page instead
        next()
      } else {
        // Continue to the login page
        next({ name: 'login' })
      }
    },
  },
  {
    path: '/admin/run-sheets',
    name: 'run-sheets',
    component: () => lazyLoadView(import('@views/run-sheets')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn'] && store.getters['auth/getUserRole'] != null) {
        // Redirect to the dashboard page instead
        next()
      } else {
        // Continue to the login page
        next({ name: 'login' })
      }
    },
  },
  {
    path: '/admin/collections',
    name: 'collections',
    component: () => lazyLoadView(import('@views/collections')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn'] && store.getters['auth/getUserRole'] != null) {
        // Redirect to the dashboard page instead
        next()
      } else {
        // Continue to the login page
        next({ name: 'login' })
      }
    },
  },
  {
    path: '/admin/all-collections',
    name: 'all-collections',
    component: () => lazyLoadView(import('@views/all-collections')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn'] && store.getters['auth/getUserRole'] != null) {
        // Redirect to the dashboard page instead
        next()
      } else {
        // Continue to the login page
        next({ name: 'login' })
      }
    },
  },
  {
    path: '/admin/requested-collections',
    name: 'requested-collections',
    component: () => lazyLoadView(import('@views/requested-collections')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn'] && store.getters['auth/getUserRole'] != null) {
        // Redirect to the dashboard page instead
        next()
      } else {
        // Continue to the login page
        next({ name: 'login' })
      }
    },
  },
  {
    path: '/admin/reassign-collections',
    name: 'reassign-collections',
    component: () => lazyLoadView(import('@views/reassign-collections')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn'] && store.getters['auth/getUserRole'] != null) {
        // Redirect to the dashboard page instead
        next()
      } else {
        // Continue to the login page
        next({ name: 'login' })
      }
    },
  },
  {
    path: '/admin/unassigned-collections',
    name: 'unassigned-collections',
    component: () => lazyLoadView(import('@views/unassigned-collections')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn'] && store.getters['auth/getUserRole'] != null) {
        // Redirect to the dashboard page instead
        next()
      } else {
        // Continue to the login page
        next({ name: 'login' })
      }
    },
  },
  {
    path: '/admin/incomplete-collections',
    name: 'incomplete-collections',
    component: () => lazyLoadView(import('@views/incomplete-collections')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn'] && store.getters['auth/getUserRole'] != null) {
        // Redirect to the dashboard page instead
        next()
      } else {
        // Continue to the login page
        next({ name: 'login' })
      }
    },
  },
  {
    path: '/admin/depots',
    name: 'depots',
    component: () => lazyLoadView(import('@views/depots')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn'] && store.getters['auth/getUserRole'] != null) {
        // Redirect to the dashboard page instead
        next()
      } else {
        // Continue to the login page
        next({ name: 'login' })
      }
    },
  },
  {
    path: '/admin/routes',
    name: 'routes',
    component: () => lazyLoadView(import('@views/routes')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn'] && store.getters['auth/getUserRole'] != null) {
        // Redirect to the dashboard page instead
        next()
      } else {
        // Continue to the login page
        next({ name: 'login' })
      }
    },
  },
  {
    path: '/admin/service-charges',
    name: 'service-charges',
    component: () => lazyLoadView(import('@views/service-charges')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn'] && store.getters['auth/getUserRole'] != null) {
        // Redirect to the dashboard page instead
        next()
      } else {
        // Continue to the login page
        next({ name: 'login' })
      }
    },
  },
  {
    path: '/admin/tips',
    name: 'tips',
    component: () => lazyLoadView(import('@views/tips')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn']) {
        // Redirect to the dashboard page instead
        next()
      } else {
        // Continue to the login page
        next({ name: 'login' })
      }
    },
  },
  {
    path: '/admin/vehicles',
    name: 'vehicles',
    component: () => lazyLoadView(import('@views/vehicles')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn'] && store.getters['auth/getUserRole'] != null) {
        // Redirect to the dashboard page instead
        next()
      } else {
        // Continue to the login page
        next({ name: 'login' })
      }
    },
  },
  {
    path: '/admin/equipment',
    name: 'equipment',
    component: () => lazyLoadView(import('@views/equipments')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn'] && store.getters['auth/getUserRole'] != null) {
        // Redirect to the dashboard page instead
        next()
      } else {
        // Continue to the login page
        next({ name: 'login' })
      }
    },
  },
  {
    path: '/admin/bins-to-be-completed',
    name: 'bins-to-be-completed',
    component: () => lazyLoadView(import('@views/bins-to-be-completed')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn'] && store.getters['auth/getUserRole'] != null) {
        // Redirect to the dashboard page instead
        next()
      } else {
        // Continue to the login page
        next({ name: 'login' })
      }
    },
  },
  {
    path: '/admin/waste-reports',
    name: 'waste-reports',
    component: () => lazyLoadView(import('@views/reports/waste-reports')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn'] && store.getters['auth/getUserRole'] != null) {
        // Redirect to the dashboard page instead
        next()
      } else {
        // Continue to the login page
        next({ name: 'login' })
      }
    },
  },
  {
    path: '/admin/run-sheet-report',
    name: 'run-sheet-report',
    component: () => lazyLoadView(import('@views/reports/run-sheet-report')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn'] && store.getters['auth/getUserRole'] === 'Admin') {
        // Redirect to the dashboard page instead
        next()
      } else {
        // Continue to the login page
        next({ name: 'login' })
      }
    },
  },
  {
    path: '/admin/services-collected-report',
    name: 'services-collected-report',
    component: () => lazyLoadView(import('@views/reports/services-collected-report')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn'] && store.getters['auth/getUserRole'] === 'Admin') {
        // Redirect to the dashboard page instead
        next()
      } else {
        // Continue to the login page
        next({ name: 'login' })
      }
    },
  },
  {
    path: '/admin/manage-users',
    name: 'manage-users',
    component: () => lazyLoadView(import('@views/users')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn'] && store.getters['auth/getUserRole'] === 'Admin') {
        // Redirect to the dashboard page instead
        next()
      }else if(store.getters['auth/loggedIn'] && store.getters['auth/getUserRole'] === 'User'){
        next({ name: 'dashboard' })
      } else {
        // Continue to the login page
        next({ name: 'login' })
      }
    },
  },
  {
    path: '/admin/recycling-reports',
    name: 'admin-recycling-reports',
    component: () => lazyLoadView(import('@views/reports/recycling-reports')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn']) {
        // Redirect to the dashboard page instead
        next()
      } else {
        // Continue to the login page
        next({ name: 'login' })
      }
    },
  },
  {
    path: '/admin/vehicle-reports',
    name: 'vehicle-reports',
    component: () => lazyLoadView(import('@views/reports/vehicle-reports')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn'] && store.getters['auth/getUserRole'] != null) {
        // Redirect to the dashboard page instead
        next()
      } else {
        // Continue to the login page
        next({ name: 'login' })
      }
    },
  },
  {
    path: '/admin/client-reports',
    name: 'client-reports',
    component: () => lazyLoadView(import('@views/reports/client-reports')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn']) {
        // Redirect to the dashboard page instead
        next()
      } else {
        // Continue to the login page
        next({ name: 'clientLogin' })
      }
    },
  },
  {
    path: '/admin/all-clients-reports',
    name: 'all-clients-reports',
    component: () => lazyLoadView(import('@views/reports/clients-list')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn']) {
        // Redirect to the dashboard page instead
        next()
      } else {
        // Continue to the login page
        next({ name: 'clientLogin' })
      }
    },
  },
  {
    path: '/admin/view-client-reports/:id',
    name: 'view-client-reports',
    component: () => lazyLoadView(import('@views/reports/view-client-reports')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn'] && store.getters['auth/getUserRole'] != null) {
        // Redirect to the dashboard page instead
        next()
      } else {
        // Continue to the login page
        next({ name: 'login' })
      }
    },
  },
  {
    path: '/admin/view-client/:id',
    name: 'view-client',
    component: () => lazyLoadView(import('@views/view-client')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn'] && store.getters['auth/getUserRole'] != null) {
        // Redirect to the dashboard page instead
        next()
      } else {
        // Continue to the login page
        next({ name: 'login' })
      }
    },
  },
  {
      path: '/admin/view-service/:id',
      name: 'view-service',
      component: () => lazyLoadView(import('@views/view-service')),
      beforeEnter(routeTo, routeFrom, next) {
          // If the user is already logged in
          if (store.getters['auth/loggedIn'] && store.getters['auth/getUserRole'] != null) {
              next()
          } else {
              // Continue to the login page
              next({ name: 'login' })
          }
      },
  },
  {
    path: '/admin/view-driver/:id',
    name: 'view-driver',
    component: () => lazyLoadView(import('@views/view-driver')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn'] && store.getters['auth/getUserRole'] != null) {
        next()
      } else {
        // Continue to the login page
        next({ name: 'login' })
      }
    },
  },
  {
    path: '/admin/view-user/:id',
    name: 'view-user',
    component: () => lazyLoadView(import('@views/view-user')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn'] && store.getters['auth/getUserRole'] != null) {
        next()
      } else {
        // Continue to the login page
        next({ name: 'login' })
      }
    },
  },
  {
        path: '/admin/view-site/:id',
        name: 'view-site',
        component: () => lazyLoadView(import('@views/view-site')),
        beforeEnter(routeTo, routeFrom, next) {
            // If the user is already logged in
            if (store.getters['auth/loggedIn'] && store.getters['auth/getUserRole'] != null) {
                next()
            } else {
                // Continue to the login page
                next({ name: 'login' })
            }
        },
    },
  {
    path: '/admin/view-collection/:id',
    name: 'view-collection',
    component: () => lazyLoadView(import('@views/view-collection')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn'] && store.getters['auth/getUserRole'] != null) {
        next()
      } else {
        // Continue to the login page
        next({ name: 'login' })
      }
    },
  },
  {
    path: '/admin/view-collection-notes-photos/:id',
    name: 'view-collection-notes-photos',
    component: () => lazyLoadView(import('@views/view-collection-notes-photos')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn'] && store.getters['auth/getUserRole'] != null) {
        next()
      } else {
        // Continue to the login page
        next({ name: 'login' })
      }
    },
  },
  {
    path: '/admin/view-runsheet/:id',
    name: 'view-runsheet',
    component: () => lazyLoadView(import('@views/view-runsheet')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn'] && store.getters['auth/getUserRole'] != null) {
        next()
      } else {
        // Continue to the login page
        next({ name: 'login' })
      }
    },
  },
  {
    path: '/admin/view-depot/:id',
    name: 'view-depot',
    component: () => lazyLoadView(import('@views/view-depot')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn'] && store.getters['auth/getUserRole'] != null) {
        next()
      } else {
        // Continue to the login page
        next({ name: 'login' })
      }
    },
  },
  {
    path: '/admin/view-route/:id',
    name: 'view-route',
    component: () => lazyLoadView(import('@views/view-route')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn'] && store.getters['auth/getUserRole'] != null) {
        next()
      } else {
        // Continue to the login page
        next({ name: 'login' })
      }
    },
  },
  {
      path: '/admin/service-types',
      name: 'admin-service-types',
      component: () => lazyLoadView(import('@views/service-types')),
      beforeEnter(routeTo, routeFrom, next) {
          // If the user is already logged in
          if (store.getters['auth/loggedIn'] && store.getters['auth/getUserRole'] != null) {
              next()
          } else {
              // Continue to the login page
              next({ name: 'login' })
          }
      },
  },
  {
      path: '/admin/charge-types',
      name: 'admin-charge-types',
      component: () => lazyLoadView(import('@views/charge-types')),
      beforeEnter(routeTo, routeFrom, next) {
          // If the user is already logged in
          if (store.getters['auth/loggedIn'] && store.getters['auth/getUserRole'] != null) {
              next()
          } else {
              // Continue to the login page
              next({ name: 'login' })
          }
      },
  },
  {
      path: '/admin/messages',
      name: 'messages',
      component: () => lazyLoadView(import('@views/messages')),
      beforeEnter(routeTo, routeFrom, next) {
          // If the user is already logged in
          if (store.getters['auth/loggedIn'] && store.getters['auth/getUserRole'] != null) {
              next()
          } else {
              // Continue to the login page
              next({ name: 'login' })
          }
      },
  },
    {
        path: '/admin/waste-types',
        name: 'waste-types',
        component: () => lazyLoadView(import('@views/waste-types')),
        beforeEnter(routeTo, routeFrom, next) {
            // If the user is already logged in
            if (store.getters['auth/loggedIn'] && store.getters['auth/getUserRole'] != null) {
                next()
            } else {
                // Continue to the login page
                next({ name: 'login' })
            }
        },
    },
  {
    path: '/admin/view-vehicle/:id',
    name: 'view-vehicle',
    component: () => lazyLoadView(import('@views/view-vehicle')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn'] && store.getters['auth/getUserRole'] != null) {
        next()
      } else {
        // Continue to the login page
        next({ name: 'login' })
      }
    },
  },
  {
    path: '/admin/view-tyrelog/:id',
    name: 'view-tyrelog',
    component: () => lazyLoadView(import('@views/view-tyrelog')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn'] && store.getters['auth/getUserRole'] != null) {
        next()
      } else {
        // Continue to the login page
        next({ name: 'login' })
      }
    },
  },
  {
    path: '/admin/view-truck-service/:id',
    name: 'view-truck-service',
    component: () => lazyLoadView(import('@views/view-truck-service')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn'] && store.getters['auth/getUserRole'] != null) {
        next()
      } else {
        // Continue to the login page
        next({ name: 'login' })
      }
    },
  },
  {
    path: '/admin/login',
    name: 'login',
    component: () => lazyLoadView(import('@views/login')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn'] && store.getters['auth/getUserRole'] != null) {
        // Redirect to the dashboard page instead
        next({ name: 'dashboard' })
      } else {
        // Continue to the login page
        next()
      }
    },
  },
  {
    path: '/admin/forget',
    name: 'forget',
    component: () => lazyLoadView(import('@views/forget')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn'] && store.getters['auth/getUserRole'] != null) {
        // Redirect to the dashboard page instead
        next({ name: 'dashboard' })
      } else {
        // Continue to the login page
        next()
      }
    },
  },
  {
    path: '/forget',
    name: 'clientforget',
    component: () => lazyLoadView(import('@views/forgetClient')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn']) {
        // Redirect to the dashboard page instead
        next({ name: 'dashboard' })
      } else {
        // Continue to the login page
        next()
      }
    },
  },
  {
    path: '/driver/forget',
    name: 'driverforget',
    component: () => lazyLoadView(import('@views/forget')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn']) {
        // Redirect to the dashboard page instead
        next({ name: 'dashboard' })
      } else {
        // Continue to the login page
        next()
      }
    },
  },
  {
    path: '/admin/resetpassword/:token',
    name: 'resetpassword',
    component: () => lazyLoadView(import('@views/resetpassword')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn']) {
        // Redirect to the dashboard page instead
        next({ name: 'dashboard' })
      } else {
        // Continue to the login page
        next()
      }
    },
  },
  {
    path: '/client/resetpassword/:token',
    name: 'resetpasswordclient',
    component: () => lazyLoadView(import('@views/resetpasswordclient')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn']) {
        // Redirect to the dashboard page instead
        next({ name: 'dashboard' })
      } else {
        // Continue to the login page
        next()
      }
    },
  },
  {
    path: '/driver/resetpassword/:token',
    name: 'resetpassworddriver',
    component: () => lazyLoadView(import('@views/resetpassworddriver')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn']) {
        // Redirect to the dashboard page instead
        next({ name: 'dashboard' })
      } else {
        // Continue to the login page
        next()
      }
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
    },
    beforeEnter(routeTo, routeFrom, next) {
      let user = store.getters['auth/getCurrentUser'];
      store.dispatch('auth/logOut');

      // if its a client show client login
      if(user.client_id){
        next({ name: 'clientLogin' })
      } else {
        next({ name: 'login' })
      }
      // const authRequiredOnPreviousRoute = routeFrom.matched.some(
      //   route => route.meta.authRequired
      // )
      // // Navigate back to previous page, or dashboard as a fallback
      // next(
      //   authRequiredOnPreviousRoute ? { name: 'dashboard' } : { ...routeFrom }
      // )
    },
  },
    /*
    * CLIENT SIDE ROUTES
    * */
  {
      path: '/login',
      name: 'clientLogin',
      component: () => lazyLoadView(import('@views/client/login')),
      beforeEnter(routeTo, routeFrom, next) {
          // If the user is already logged in
          if (store.getters['auth/loggedIn']) {
              // Redirect to the dashboard page instead
              next({ name: 'my-services' })
          } else {
              // Continue to the login page
              next()
          }
      },
  },
  {
    path: '/my-services',
    name: 'my-services',
    component: () => lazyLoadView(import('@views/client/my-services')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn']) {
        // Redirect to the dashboard page instead
        next()
      } else {
        // Continue to the login page
        next({ name: 'clientLogin' })
      }
    },
  },
  {
    path: '/invoices',
    name: 'invoices',
    component: () => lazyLoadView(import('@views/client/invoices')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn']) {
        // Redirect to the dashboard page instead
        next()
      } else {
        // Continue to the login page
        next({ name: 'clientLogin' })
      }
    },
  },
  {
    path: '/reports',
    name: 'recycling-reports',
    component: () => lazyLoadView(import('@views/client/recycling-reports')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn']) {
        // Redirect to the dashboard page instead
        next()
      } else {
        // Continue to the login page
        next({ name: 'clientLogin' })
      }
    },
  },

  {
    path: '/my-account',
    name: 'my-account',
    component: () => lazyLoadView(import('@views/client/my-account')),
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn']) {
        // Redirect to the dashboard page instead
        next()
      } else {
        // Continue to the login page
        next({ name: 'clientLogin' })
      }
    },
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: 'dashboard',
    beforeEnter(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn']) {
        // Redirect to the dashboard page instead
        next({ name: 'dashboard' })
      } else {
        // Continue to the login page
        next({ name: 'login' })
      }
    }
  },
]

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//

function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require('@views/loading').default,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    error: require('@views/timeout').default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 400,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    },
  })
}
